export const spacingUtil = (factor: number): string => `${factor * 8}px`;
